// The tags tree-select returns autotag groups as comma-joined id strings (e.g. '12, 13').
// Flatten everything to a plain list of numeric tag ids for the `tag_ids` query param.
export function flattenTagSelection(items: Array<number | string>): Array<number> {
    return items
        .flatMap((item) => String(item).split(','))
        .map((item) => Number(item.trim()))
        .filter((item) => Number.isFinite(item));
}
